module.exports = __webpack_public_path__ + "img/Podiatry.6ffa673.png";